import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../../../layout";
import TextWithImg from "./../../common/TextWithImg";
import Describtions from './describtions'
import Forms from './forms';
import Customers from './Customers';

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  from: {
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  img1: {
    position: "absolute",
    left: -80,
    bottom: -230,
  },
  img2: {
    position: "absolute",
    right: -120,
    bottom: 40,
  },
}));

export default function Index() {
  const classes = useStyles();
  let state = {
    title: "همراهی با شما، افتخار ما است...",
    content:`
    شرکت کارگزاری پویان با پایبندی به نظام ارزشی جامعه، با برخورداری از سرمایه‌های انسانی با ذهنیت یادگیرنده، خلاق و متخصص به دنبال تجربه لذت کاربرد ابزارهای مالی با استفاده از آگاهی و سواد مالی برای عموم جامعه و با هدف برقراری روابط بلندمدت و سودآور برای ذینفعان شرکت می‌باشد. تبدیل شدن به کارگزار برتر در ارائه خدمات نوآور، با فناوری بالا و استاندارد صنعت از اهداف بلندمدت شرکت می‌باشد.
ما تلاش می‌کنیم با تکیه بر سرمایه‌های انسانی و با تعقیب و تصویرسازی آینده جدید و متفاوت در خدمات کارگزاری، در راستای بهبود و توسعه آن گام برداریم، و نوع نگاه به بازار سرمایه را به ماهیت واقعی آن نزدیک و راه‌های دستیابی به آن را تسهیل نمایم، تا بنگاه‌های اقتصادی و سرمایه‌گذاران بتواند از سرمایه در دسترس، با آگاهی و سواد مالی و سرمایه‌گذاری با حداکثرسازی منافع خود، استفاده و دامنه تصمیمات آگاهانه خود را گسترش دهند.
ما باور داریم باید در مسیر حرکت تغییر و تحولات دنیای تکنولوژی و ارائه خدمات، ابزارهای توانمندسازی متناسب با نیازهای مشتریان را توسعه و در دسترس قرار دهیم، و بستر مناسبی برای سرمایه‌گذاری و دستاوردهای بیشتر برای مشتریان خود فراهم کنیم.
    `,
    src: "newImages/Churb.jpg",
  };

  return (
    <Layout>
      <div className={classes["root"]}>
        <TextWithImg data={state} />
      </div>
      <div className={classes["from"]}>
        <Describtions />
        <Forms />
        <Customers/>
      </div>
    </Layout>
  );
}
